export function formatCurrency(value: number): string {
  if (!isFinite(value) || isNaN(value)) return '--'
  return value.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
}

export function formatCurrencyShort(value: number): string {
  if (!isFinite(value) || isNaN(value)) return '--'
  if (value >= 1_000_000) return `R$ ${(value / 1_000_000).toFixed(1)}M`
  if (value >= 1_000) return `R$ ${(value / 1_000).toFixed(1)}K`
  return formatCurrency(value)
}

export function formatPercent(value: number, decimals = 1): string {
  if (!isFinite(value) || isNaN(value)) return '--'
  return `${value.toFixed(decimals)}%`
}

export function formatNumber(value: number, decimals = 0): string {
  if (!isFinite(value) || isNaN(value)) return '--'
  return value.toLocaleString('pt-BR', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  })
}

export function formatMultiplier(value: number): string {
  if (!isFinite(value) || isNaN(value)) return '--'
  return `${value.toFixed(2)}x`
}

export function safeDiv(numerator: number, denominator: number): number {
  if (denominator === 0 || !isFinite(denominator)) return 0
  return numerator / denominator
}

export function costDiv(cost: number, quantity: number): number {
  if (quantity <= 0 || !isFinite(quantity)) return Infinity
  return cost / quantity
}
